<template>
  <div class="col pa-0" :class="field.props.center ? 'col-5' : 'col-12'" :style="field.props.center ? 'margin-right:auto; margin-left:auto;' : ''">
      <v-alert icon="$warning_s" dense text type="warning" class="">
        <span v-html="$t(field.text)"></span>
      </v-alert>
  </div>
</template>

<script>
import validate from '../functions/validations'

export default {
  props: ["model", "fieldName", "field"],
  mixins: [validate], 
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>